import { render, staticRenderFns } from "./ConfigDetailTable.vue?vue&type=template&id=d5be9a42&"
import script from "./ConfigDetailTable.vue?vue&type=script&lang=js&"
export * from "./ConfigDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports